import TranslationUtils from '@gik/core/utils/TranslationUtils';
import { StartInkindContentBlockName } from '../../StartInkindCard/StartInkindContent';

const translations = {
  title: 'Start an inkind page',
  description: 'Truly helpful, truly free.',
};

export default {
  [StartInkindContentBlockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(StartInkindContentBlockName, translations);
